// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mob2cadpubKey: 'pub-c-83f3d03e-317d-47f0-b027-0e7655feb6a0',
  mob2cadsubkey:'sub-c-b1e06506-28ed-4b8e-91dc-aa260dfc6e57',
  pubkey : 'pub-c-6fb784ad-27b9-4bf3-a917-02f3f445dafe',
  subkey : 'sub-c-71c86e22-449f-11eb-a233-facb2062b65c',
  // dotpubkey : 'pub-c-6fb784ad-27b9-4bf3-a917-02f3f445dafe',
  // dotsubkey : 'sub-c-71c86e22-449f-11eb-a233-facb2062b65c',
  dotpubkey : 'pub-c-6fb784ad-27b9-4bf3-a917-02f3f445dafe',
  dotsubkey : 'sub-c-71c86e22-449f-11eb-a233-facb2062b65c',
  // hae2hatapi: 'https://pinnacle.nextnavapis.io/v2/hae-to-hat',
  // hae2hatkey : '6OpDRM6Aep2Rm4dqlgQD236amTphhqa2aezg9qi7',
  hae2hatapi: 'https://dev.nextnav.io/gs/v2/hae-to-hat',
  hae2hatkey : '9PUArYRvwCiyMNAfqzkH91CyYHJ90kY6QzzW1nI3',
  testButton : true,
  nwlat : 37.38390,
  mwlon : -121.97849,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.